import type { formulario as pt } from '../pt-BR/formulario';
import type { Traducao } from '../Traducao';

export const formulario = {
  saudacao: 'Hola, {{nome}}',
  abertaAte: 'Abierta hasta {{fim}}',
  semCampanha: 'No hay ninguna campaña abierta en este momento.',
  selecione: 'Seleccione',
  motivos: {
    SEM_VINCULO:
      'No encontramos su registro de profesional. Contacte al equipo responsable de la campaña.',
    NAO_PARTICIPANTE:
      'Usted no está en la lista de participantes de esta campaña. Contacte al equipo responsable de la campaña.',
    PARTICIPANTE_EXCLUIDO: 'Usted ya no forma parte de esta campaña.',
    CAMPANHA_AGENDADA: 'La campaña comienza el {{inicio}}.',
    CAMPANHA_FECHADA: 'La campaña no está aceptando respuestas.',
  },
  somenteLeitura: 'Sus respuestas ya no se pueden modificar.',
  brinde: {
    pergunta: '¿Le gustaría recibir un obsequio de NTConsult de fin de año 2026?',
  },
  camiseta: {
    titulo: 'Talla de la camiseta',
    manterTamanho: 'Mantener {{tamanho}}',
    trocar: 'Cambiar',
    escolha: '¿Cuál es su talla de camiseta?',
    exteriorHint:
      'Para el extranjero no enviamos camiseta. La talla que indique actualiza su registro.',
  },
  entrega: {
    titulo: '¿Podemos entregar en esta dirección o prefiere recibirlo en otra?',
    aviso:
      'Previsión de entrega: <strong>{{janela}}</strong>. Para la dirección en Brasil indicada por usted, por favor, verifique con calma que sea correcta. <strong>Es necesario que haya una persona disponible para recibirlo cuando llegue.</strong>',
    avisoDatas:
      'Previsión de entrega: <strong>entre {{inicio}} y {{fim}}</strong>. Para la dirección en Brasil indicada por usted, por favor, verifique con calma que sea correcta. <strong>Es necesario que haya una persona disponible para recibirlo cuando llegue.</strong>',
    avisoSemJanela:
      'Para la dirección en Brasil indicada por usted, por favor, verifique con calma que sea correcta. <strong>Es necesario que haya una persona disponible para recibirlo cuando llegue.</strong>',
    cadastro: 'Entregar en esta dirección',
    outro: 'Entregar en otra',
    outroTitulo: '¿En qué dirección le gustaría recibir el obsequio de fin de año 2026?',
    completar: 'Completar la dirección del registro',
    separado:
      'Separamos el número y el complemento del nombre de la calle. Compruebe que es correcto.',
    numeroPodeEstarJunto:
      'El número puede estar junto al nombre de la calle. Revise los dos campos.',
    corrigir: '¿No es correcto? Corregir',
    enderecoOriginal: 'En el registro dice:',
    exterior: 'Vivo en el extranjero y quiero recibirlo en el extranjero',
    exteriorDescricao:
      'Para el extranjero enviamos un neceser, sin personalización y sin camiseta.',
    avisoExterior:
      'Para direcciones en el extranjero, enviamos un <strong>neceser sin personalización</strong>, comprado en una tienda local. El plazo varía de un país a otro. Por favor, verifique con calma que su dirección sea correcta. <strong>Es necesario que haya una persona disponible para recibirlo cuando llegue.</strong>',
    cadastroExterior:
      'La dirección de su registro está fuera de Brasil. Para recibir el regalo personalizado, indique una dirección en Brasil; o elija recibirlo en el extranjero.',
    exteriorTitulo: '¿En qué dirección en el extranjero le gustaría recibirlo?',
    telefoneHint:
      'Con el código del país, por ejemplo +351 912 345 678. Se usa solo para la entrega.',
  },
  campos: {
    cep: 'CEP',
    logradouro: 'Calle',
    logradouroExemplo: 'Calle, avenida etc',
    numero: 'Número',
    complemento: 'Complemento — opcional',
    complementoExemplo: 'Apartamento, casa, bloque etc',
    bairro: 'Barrio',
    cidade: 'Ciudad',
    uf: 'Estado',
    estado: 'Estado',
    pais: 'País',
    enderecoLivre: 'Dirección (calle, número, complemento)',
    endereco: 'Dirección',
    regiao: 'Estado, provincia o región — opcional',
    codigoPostal: 'Código postal — opcional',
    telefone: 'Teléfono',
    numeroOpcional: 'Número — opcional',
    bairroOpcional: 'Barrio — opcional',
  },
  oficial: {
    titulo: 'Dirección oficial en el registro',
    cidadeAusente: '¿No encuentra su ciudad? Contacte al equipo responsable de la campaña.',
    semCidades: 'Ninguna ciudad encontrada',
    exteriorHint:
      'Fuera de Brasil, la ciudad y el estado pueden no existir en el registro; en ese caso, el equipo lo completa después.',
  },
  cep: {
    buscando: 'Buscando la dirección…',
    preenchido: 'Dirección completada con el código postal. Revise los datos e indique el número.',
    parcial: 'Este código postal abarca toda la ciudad. Indique la calle y el barrio.',
    naoEncontrado:
      'No encontramos este código postal. Revise el número o complete la dirección manualmente.',
    indisponivel:
      'No fue posible consultar el código postal ahora. Complete la dirección manualmente.',
    cidadeNaoCasou: 'No encontramos la ciudad en la lista del registro. Elíjala manualmente.',
  },
  confirmar: {
    previsao: 'Entrega prevista',
    semBrinde: 'No quiero el obsequio',
    cadastro: 'Registro',
    corrigirCadastro: 'Corregir la dirección de mi registro',
    alterar: 'Cambiar',
    intro:
      'La entrega del obsequio depende de que se envíe la dirección correcta y de que haya alguien disponible para recibirlo. Si no está seguro, puede volver y verificar.',
    enderecoCorreto: 'Sí, confirmo que mi dirección de entrega es correcta.',
    recebedor: 'Sí, habrá alguien disponible para recibir la entrega.',
    titulo: 'Confirmación',
  },
  enviar: 'Enviar respuestas',
  salvarAlteracoes: 'Guardar cambios',
  validacao: {
    cep: 'Indique un CEP de 8 dígitos.',
    telefone: 'Indique un teléfono con el código del país, de 8 a 15 dígitos.',
    tamanho: 'Use como máximo {{max}} caracteres.',
    obrigatorio: 'Obligatorio.',
  },
  resumo: {
    tamanho: 'Talla de la camiseta',
    entrega: 'Dirección de entrega',
    oficialSem: 'Sin cambios',
    entregaExterior: 'Entrega en el extranjero (neceser)',
  },
  axiis: {
    camiseta: { sucesso: 'Talla de la camiseta actualizada en su registro.' },
    endereco: { sucesso: 'Dirección oficial actualizada en su registro.' },
    pendente:
      'Sus respuestas están guardadas. La actualización de su registro aún no se completó; el equipo la completará. No necesita enviar de nuevo.',
  },
  passos: {
    progresso: 'Paso {{atual}} de {{total}}',
    continuar: 'Continuar',
    voltar: 'Volver',
  },
  mesmo: {
    pergunta:
      '¿Podemos considerar esta como su nueva dirección y actualizarla en nuestros sistemas?',
    sim: 'Sí, esta es mi nueva dirección y quiero actualizarla',
    nao: 'No, esta es solo la dirección donde quiero recibir el obsequio',
  },
  cadastro: {
    titulo: 'Dirección de su registro',
    certo: 'Está correcta',
    corrigir: 'Corregir',
    pular: 'Omitir',
  },
  respondido: {
    selo: 'Respondido',
    quando: 'Enviado el {{quando}}',
    alterar: 'Cambiar respuestas',
  },
  link: {
    titulo: 'Enlace de la campaña',
    copiar: 'Copiar enlace',
  },
} as const satisfies Traducao<typeof pt>;
